import React, {useState, useEffect, useContext, useRef} from "react";
import Switch from "../common/Switch";
import NavTopicItem from "./NavTopicItem";
import {ChevronRightIcon, ArrowLeftIcon} from "../common/icons";
import ListGroup from "../common/ListGroup";
import NavConceptItem from "./NavConceptItem";
import {BrandContext} from "../common/BrandContext";
import {UserContext} from "../common/UserContext";
import {TemplateContext} from "../common/TemplateContext";
import axios from "../common/axios";
import useCurrentConcept from "../hooks/useCurrentConcept";
import CircularLoader from "../common/CircularLoader";
import NavDocumentItem from "./NavDocumentItem";
import TextbookIcon from "../common/icons/TextbookIcon";
import ListItemCore from "../common/ListItemCore";
import {useScreenMode} from "../common/context/ScreenModeContext";

const NavigateCourse = props => {
    const {syllabusId, classId, visible = false, callback, handleToggleSeriesDropdown} = props;
    const {user, setUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {singlePage} = useContext(TemplateContext);
    const {loadCurrentConcept} = useCurrentConcept();
    const [topicGroups, setTopicGroups] = useState([]);
    const [topic, setTopic] = useState();
    const [conceptId, setConceptId] = useState();
    const [concepts, setConcepts] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [enabledTopics, setEnabledTopics] = useState(new Set());
    const [enabledConcepts, setEnabledConcepts] = useState([]);
    const [enableAll, setEnableAll] = useState(false);
    const [conceptsActive, setConceptsActive] = useState(false);
    const {mobileScreenMode} = useScreenMode();

    const handleChangeTopic = (updateTopic) => {
        if (topic?.topicId === updateTopic?.topicId) {
            setConceptsActive(true);
        }
        setTopic(updateTopic);
        handleToggleSeriesDropdown(false);
        setConceptsActive(true);
    };

    const handleChangeConcept = (updateConceptId) => {
        setConceptId(updateConceptId);
        if (updateConceptId) {
            if (singlePage) {
                if (typeof callback === 'function') callback();
                loadCurrentConcept(updateConceptId);
            } else {
                window.location.href = '/controlCentre/navigateSyllabuses.action?conceptId=' + updateConceptId;
            }
        }
        setConceptsActive(false);
    }

    const handleUpdateAllConcepts = (event) => {
        const locEnabled = event.target.checked;
        if(classId && syllabusId) {
            setEnableAll(locEnabled);
            axios.get('/web/ui/content/enableConceptClassesBySyllabus',  {params: {syllabusId: syllabusId, classId: classId, enabled: locEnabled}})
                .then(response => {
                    handleUpdateConcepts(response.data);
                });
        }
    };

    const handleUpdateConcepts = (updateEnabledConcepts) => {
        topicGroups.forEach(topicGroup => {
            if (topicGroup.topics.length > 0) {
                topicGroup.topics.map(locTopic => {
                    const topicConceptIds = locTopic.concepts.map(concept => concept.conceptId);
                    const enabledTopic = topicConceptIds.some(topicConceptId => updateEnabledConcepts.includes(topicConceptId));
                    if (enabledTopic) {
                        enabledTopics.add(locTopic.topicId);
                    } else {
                        enabledTopics.delete(locTopic.topicId);
                    }
                });
            }
        });
        setEnabledConcepts(updateEnabledConcepts);
        setEnableAll(updateEnabledConcepts.length > 0);
    };

    const handleReturnToTopics = () => {
        setConceptsActive(false);
        handleToggleSeriesDropdown(true);
    }

    const handleTabListKeyDown = (event) => {
        const tabs = [];
        topicGroups.forEach(topicGroup => {
            topicGroup.topics.forEach(locTopic => {
                if (!locTopic.disabled) {
                    tabs.push(locTopic);
                }
            });
        });

        const currentIndex = tabs.findIndex(t => t.topicId === topic?.topicId);
        let nextIndex = currentIndex;

        switch (event.key) {
            case 'ArrowUp':
                event.preventDefault();
                nextIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
                break;
            case 'ArrowDown':
                event.preventDefault();
                nextIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
                break;
            case 'Home':
                event.preventDefault();
                nextIndex = 0;
                break;
            case 'End':
                event.preventDefault();
                nextIndex = tabs.length - 1;
                break;
            default:
                return;
        }

        if (nextIndex !== currentIndex && tabs[nextIndex]) {
            handleChangeTopic(tabs[nextIndex]);
            // Focus the new tab after state updates
            setTimeout(() => {
                const nextTab = document.getElementById(`topic-${tabs[nextIndex].topicId}`);
                if (nextTab) {
                    nextTab.focus();
                }
            }, 0);
        }
    }

    useEffect(() => {
        if (syllabusId) {
            setLoading(true);
            axios.get('/web/ui/nav/syllabus/' + syllabusId + '/topicGroups')
                .then(response => {
                    setTopicGroups(response.data);
                    let newTopic = undefined,
                        firstValidTopic = undefined;

                    response.data.map(topicGroup => {
                        topicGroup.topics.map(locTopic => {
                            if (!locTopic.disabled) {
                                if (locTopic.topicId === user.topicId) {
                                    newTopic = locTopic;
                                }

                                if (firstValidTopic === undefined) {
                                    firstValidTopic = locTopic;
                                }
                            }
                        });
                    });

                    if (newTopic === undefined) {
                        newTopic = firstValidTopic;
                    }
                    setTopic(newTopic);
                    setLoading(false);
                });
        }
    }, [syllabusId]);

    useEffect(() => {
        if (topic !== undefined) {
            setConcepts(topic.concepts);
        }
    }, [topic]);

    useEffect(() => {
        if (concepts !== undefined && concepts.length > 0) {
            concepts.map(concept => {
                if (concept.conceptId === user.conceptId && !concept.disabled) {
                    setConceptId(concept.conceptId);
                }
            });
            $('.ch-series-menu-group .ch-mathjax').reloadMathJax();
        }
    }, [concepts]);

    useEffect(() => {
        if (brandConfig.disableConcepts && classId && syllabusId) {
            axios.get('/web/ui/content/class/' + classId+ '/syllabus/'+ syllabusId + '/enabledConcepts')
                .then(response => {
                    const updateEnabledConcepts = response.data;
                    handleUpdateConcepts(updateEnabledConcepts);
                });
        }
    }, [classId, topicGroups, syllabusId]);

    useEffect(() => {
        if (!isLoading) {
            $('.ch-series-menu-group .ch-mathjax').reloadMathJax();
        }
    }, [isLoading]);

    if (isLoading) {
        return (
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <CircularLoader/>
            </div>
        )
    }

    return (
        <div className={'ch-series-menu-group'}>
            {brandConfig.disableConcepts && user.teacher && classId !== undefined &&
                <div className={'ch-series-menu-show-all'}>
                    <Switch size="small" color="primary" name="enableAll" checked={enableAll} onChange={handleUpdateAllConcepts}/>
                    <span className={'ch-list-item-text'}>Show/hide all</span>
                </div>
            }
            <div aria-label={"Content Navigation"} className={'ch-series-menu-topics-concepts'}>
                <div className={`ch-series-menu-topics ${!conceptsActive ? 'ch-series-menu-visible' : ''}`}>
                    <div role="tablist"
                        aria-label={brandConfig.topicsName}
                        onKeyDown={handleTabListKeyDown}
                        className={'ch-series-menu-list ch-nav-group'}
                        aria-orientation={'vertical'}
                    >
                        {topicGroups.map((topicGroup, tgIndex) => {
                            const html = topicGroup.topics.map((locTopic, topicIndex) => {
                                return (
                                    <NavTopicItem key={locTopic.topicId}
                                                  active={topic !== undefined && locTopic.topicId === topic.topicId}
                                                  disabled={locTopic.disabled}
                                                  enabled={enabledTopics.has(locTopic.topicId)} visible={visible}
                                                  className={'margin-x--m'} topic={locTopic}
                                                  meta={<ChevronRightIcon height={20} width={20} aria-hidden="true" />}
                                                  classId={classId}
                                                  isExpanded={conceptsActive && topic?.topicId === locTopic.topicId}
                                                  handleUpdateConcepts={handleUpdateConcepts}
                                                  handleChangeTopic={handleChangeTopic}/>
                                )
                            });
                            if (topicGroup.hideName) {
                                return <React.Fragment key={tgIndex}>{html}</React.Fragment>;
                            } else {
                                return <ListGroup key={tgIndex} title={topicGroup.topicGroupName}>{html}</ListGroup>
                            }
                        })}
                    </div>
                </div>
                <div
                    id="concepts-panel"
                    role="tabpanel"
                    aria-labelledby={topic ? `topic-${topic.topicId}` : undefined}
                    className={`ch-series-menu-concepts ${conceptsActive ? 'ch-series-menu-visible' : ''}`}>
                    <ul aria-label={brandConfig.conceptsName}
                        className={'ch-series-menu-list ch-nav-group'}
                    >
                        {mobileScreenMode &&
                            <li className={'ch-list-item ch-list-item-header'}>
                                <button className={'ch-nav-item'} aria-label={'Return to topic list'}
                                   onClick={handleReturnToTopics}>
                                    <ArrowLeftIcon aria-hidden={'true'} />
                                    <ListItemCore>
                                        <span>Topics</span>
                                    </ListItemCore>
                                </button>
                            </li>
                        }
                        {concepts.map((concept, index) => {
                            return (
                                <NavConceptItem
                                    key={concept.conceptId}
                                    active={conceptId === concept.conceptId}
                                    disabled={concept.disabled}
                                    enabled={enabledConcepts.includes(concept.conceptId)}
                                    visible={visible}
                                    className={'margin-x--m'} concept={concept} classId={classId}
                                    handleUpdateConcepts={handleUpdateConcepts}
                                    handleChangeConcept={handleChangeConcept}/>
                            )
                        })}
                        {brandConfig.enableDocumentInNavigation && !user.publicSession && user.nonTrialProduct && topic !== undefined && topic.textbookId != undefined &&
                            <NavDocumentItem className={'margin-x--m'} documentId={topic.textbookId} classId={classId}>
                                <TextbookIcon/><span style={{paddingLeft: 'var(--small-spacing-unit)'}}>Student Book Chapter</span>
                            </NavDocumentItem>
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default NavigateCourse;